import {
    Card,
    Form,
    Input,
    Button,
    Space,
    Tooltip,
    message, Table, Radio, InputNumber
} from 'antd'
import {useEffect, useState} from 'react'
import {
    PlusCircleOutlined,
    ExclamationCircleOutlined
} from '@ant-design/icons'
import { useLocation } from "react-router-dom";
import service from "../../../../@services";
import moment from 'moment'
import TimeDurationFormItem from "../../../../components/TimeDurationFormItem";
import NewProductListTable from "../../../../components/NewProductListTable";
import ProductSearchModal from "../../../Product/components/ProductSearchModal";
import useOperateAddProductList from "../../../Purchase/hooks/useOperateAddProductList";
import QueryString from "qs";

const basicDurationKeys = ['beginCreateTime', 'endCreateTime']
export default function EditActivityGroup(props) {
    const [loading, setLoading] = useState(false)
    const { search } = useLocation();
    const [id, setId] = useState(null)
    const [showAddProductList, setShowAddProductList] = useState(false)
    const [supplierId, setSupplierId] = useState(null)
    const [time, setTime] = useState(['',''])
    const [tableData, setTableData] = useState([])
    const [pagination, setPagination] = useState({current: 1,pageSize: 10,})
    const [basicForm] = Form.useForm()
    useEffect(() => {
        let query = QueryString.parse(decodeURIComponent(search.replace("?", "")));
        setId(query.actId)
    }, [search]);
    useEffect(() => {
        id ? getGroupDetail(id):basicForm.setFieldsValue()
    }, [id]);
    const {
        rowKey,
        pageData,
        handleSave,
        getProductInfoBySeachModal,
        setPage
    } = useOperateAddProductList({ supplierId })
    const getGroupDetail = async () =>{
        setLoading(false)
        const data = await service.activity.getGroupDetail(id)
        setLoading(false)
        const deflautTime = []
        deflautTime[0] = moment(data.validBeginTime)
        deflautTime[1] = moment(data.validEndTime)
        data.duration = deflautTime
        basicForm.setFieldsValue(data)
        setTableData(data.products)
        setTime(deflautTime)
    }
    const handleTableChange = (pagination) => {
        setPagination(pagination)
    }
    const colums = [
        {
            title: '商品信息',
            dataIndex: 'productName',
            width: '200px',
            render: (text, record) => {
                return (
                    <div style={{ fontSize: 12 }}>
                        <div style={{ color: '#1890ff' }}>{record.productName}</div>
                        <div>商品编码：{record.productCode}</div>
                        <div>商品条码：{record.barcode}</div>
                    </div>
                )
            }
        },
        {
            title: '规格',
            dataIndex: 'specification',
            width: '80px'
        },
        {
            title: '当前售价',
            width: '100px',
            dataIndex: 'salePrice'
        },
        {
            title: '团购价格',
            dataIndex: 'actPrice',
        },
        {
            title: '活动库存',
            dataIndex: 'actStock',
        },
        {
            title: '线上销售库存',
            dataIndex: 'onlineStock'
        },
        {
            title:
                <div>
                    最低团购商品数量
                    <Tooltip placement="topLeft" title="活动结束后商品数量未达团购最低数量订单将会自动取消" arrowPointAtCenter>
                        <ExclamationCircleOutlined style={{ marginLeft: '10px' }}/>
                    </Tooltip>
                </div>
            ,
            width: '180px',
            dataIndex: 'minBuy',
        },
        {
            title: '限购规则',
            width: '220px',
            dataIndex: 'limitCount',
            render: (text) => {
                return (
                    text === -1 ? <div>不限购</div> :
                    <div>限购：单笔 {text} 件/单</div>
                )
            }
        }
    ]

    const openModal = () => {
        // 如果是采购进货不用强制判断是否选择了供应商
        setShowAddProductList(true)
    }
    const confirmProductList = async _list => {
        await getProductInfoBySeachModal(_list)
        setShowAddProductList(false)
    }
    return (
        <Card
            loading={loading}
            title='团购活动详情'
            className='customer-card'>
            <Form
                wrapperCol={{ style: { marginBottom: 20 } }}
                labelCol={{ style: { width: 90, textAlign: 'right' } }}
                initialValues={{duration: time}}
                form={basicForm}>
                <Form.Item
                    label='活动名称'
                    name='name'>
                    <Input style={{ width: 380 }} disabled={true}/>
                </Form.Item>
                <TimeDurationFormItem
                    keys={basicDurationKeys}
                    label='活动时间'
                    defaultValue={time}
                    dateFormatList={'YYYY-MM-DD HH:mm:ss'}
                    form={basicForm}
                    style={{ width: 380 }}
                    disabled={true}
                />
                <Form.Item
                    label='活动说明'
                    name='note'>
                    <Input style={{ width: 380 }} disabled={true}/>
                </Form.Item>
                <Form.Item
                    label='团购商品'
                    name='supplierId'>
                    <div style={{ margin: '0 0 20px', textAlign: 'left' }}>
                        <Space>
                            <Button
                                type='primary'
                                disabled={true}
                                icon={<PlusCircleOutlined />}
                                onClick={openModal}>
                                选择商品
                            </Button>
                        </Space>
                    </div>
                </Form.Item>
            </Form>
            <Table
                rowKey={record=>record.id}
                dataSource={tableData}
                pagination={pagination}
                loading={loading}
                columns={colums}
                scroll={{ x: 1100 }}
                onChange={handleTableChange}
            />
            <Form form={basicForm}>
                <Form.Item
                    label='商品下架配置'
                    style={{ marginTop: '20px' }}
                    name='foreOffShelf'>
                    <Radio.Group disabled={true}>
                        <Radio value={true}>允许</Radio>
                        <Radio value={false}>不允许</Radio>
                    </Radio.Group>
                </Form.Item>
                <div style={{ position: 'relative', color: '#AAAAAA', fontSize: '13px', left: '110px' }}>活动结束后商品强制下架处理</div>
            </Form>
            <Space style={{display: 'flex', justifyContent: 'center',paddingTop: '20px'}}>
                <Button onClick={()=>props.history.goBack()}>取消</Button>
            </Space>
            <ProductSearchModal
                visible={showAddProductList}
                close={() => setShowAddProductList(false)}
                confirmListHaveInfo={confirmProductList}
            />
        </Card>
    )
}
